class FooterNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form) return;

    this.success = this.querySelector("[data-newsletter-success]");
    this.errorMessage = this.querySelector("[data-newsletter-error]");
    this.inputWrapper = this.querySelector(".cta-input__input-wrapper");
    this.input = this.querySelector(".cta-input__input");

    if (this.success || this.inputWrapper?.classList.contains("error")) {
      this.revealResult();
    }

    // Absent once the form has posted successfully.
    if (!this.input) return;

    // The form is left natively validated, so the browser blocks an invalid
    // submit before any submit event fires — cancelling that event instead lost
    // a race with Shopify's spam challenge, which re-submits the form itself.
    // `invalid` does not bubble, hence the capture listener.
    this.form.addEventListener(
      "invalid",
      (event) => {
        // Suppresses the browser's own bubble, not the blocked submit.
        event.preventDefault();
        this.setError(true);
        this.input.focus();
      },
      true,
    );

    this.input.addEventListener("input", () => {
      if (this.isValid()) {
        this.setError(false);
      }
    });
  }

  // Reads validity rather than calling checkValidity(), which would fire the
  // `invalid` event above on every keystroke.
  isValid() {
    return Array.from(this.form.elements).every((field) => field.validity.valid);
  }

  setError(hasError) {
    this.inputWrapper.classList.toggle("error", hasError);
    this.input.classList.toggle("error", hasError);

    if (hasError) {
      this.input.setAttribute("aria-invalid", "true");
      return;
    }

    this.input.removeAttribute("aria-invalid");

    // Any message Shopify rejected the last submit with describes a value the
    // field no longer holds, so it reverts to the front-end one.
    this.errorMessage.textContent = this.errorMessage.dataset.defaultMessage;
  }

  // The post is native, so success and errors arrive on a fresh page load with
  // the footer off screen.
  revealResult() {
    const target = this.success || this.inputWrapper;

    (this.success || this.input).focus({ preventScroll: true });
    this.scrollToResult(target);

    // Images above the footer settle after load and shift the target away from
    // wherever the initial scroll left it.
    window.addEventListener("load", () => this.scrollToResult(target), {
      once: true,
    });
  }

  scrollToResult(target) {
    target.scrollIntoView({ block: "center", behavior: "instant" });
  }
}

if (!customElements.get("footer-newsletter")) {
  customElements.define("footer-newsletter", FooterNewsletter);
}
